import React, { useEffect, useState } from 'react';
import {
    Label, Button, Classes, Dialog,
} from '@blueprintjs/core';
import i18n from 'i18n';
import FormPanel from 'components/FormPanel';

interface ConfirmationActionsProps {
    currentStep: number;
    totalSteps: number;
    isValid: boolean;
    onClose: () => void;
    onSubmit: () => void;
    onNext: () => void;
    onBack: () => void;
}

const ConfirmationActions = ({
    currentStep,
    totalSteps,
    isValid,
    onClose,
    onSubmit,
    onNext,
    onBack,
}: ConfirmationActionsProps): JSX.Element => {
    return (
      <div className={Classes.DIALOG_FOOTER}>
        <FormPanel>
          <Button
            onClick={onClose}
            className="actionButton"
            text={i18n.t('common.button.cancel')}
          />
          {(currentStep > 1) && (
            <Button
              onClick={onBack}
              className="actionButton"
              text={i18n.t('common.button.back')}
            />
                )}
          {(currentStep < totalSteps || (currentStep === 1 && totalSteps > 1)) && (
            <Button
              onClick={onNext}
              className="actionButton"
              disabled={!isValid}
              active
              intent="primary"
              text={i18n.t('common.button.next')}
            />
                )}
          {(currentStep >= totalSteps) && (
            <Button
              onClick={onSubmit}
              className="actionButton"
              disabled={!isValid}
              active
              intent="primary"
              text={i18n.t('common.button.submit')}
            />
                )}
        </FormPanel>
      </div>
    );
};

export default ConfirmationActions;
